import { suspendedMembersDataset } from '@/lib/member-views/datasets/suspendedMembers.dataset';
import type { SuspendedMemberRow } from '@/lib/members/members.types';
import { DaysPastDueCell } from '../cells/DaysPastDueCell';
import { MemberIdentityCell } from '../cells/MemberIdentityCell';
import { PhoneCell } from '../cells/PhoneCell';
import { PriorityTagsCell } from '../cells/PriorityTagsCell';
import { MemberViewShell, type MemberViewShellProps } from '../MemberViewShell';

const cellOverrides: MemberViewShellProps<SuspendedMemberRow>['cellOverrides'] = {
  patient: (row) => <MemberIdentityCell firstName={row.firstName} lastName={row.lastName} mdvipId={row.mdvipId} />,
  daysPastDue: (row) => <DaysPastDueCell days={row.billingDaysPastDue} />,
  phone: (row) => <PhoneCell mobile={row.mobilePhone} home={row.phone} />,
  priorityTags: (row) => <PriorityTagsCell tags={row.priorityTags} />,
};

/**
 * Suspended Members: the practice's members on a billing hold.
 *
 * A function declaration for the same reason as `AllActiveMembersView`: the view registry and the
 * shell import each other, and a hoisted function survives that cycle where a `const` might not.
 */
export function SuspendedMembersView() {
  return <MemberViewShell dataset={suspendedMembersDataset} cellOverrides={cellOverrides} />;
}
